var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Row, Col } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import SelectDropdown from "../../../../../../../shared-library/components/selectdropdown";
import InputField from "@frameworks/web/components/generic/inputField";
import { FileUploadSection } from "../../../../../../../shared-library/components/fileupload/fileUploadSection";
import GenericSidebar from "@frameworks/web/components/generic/Sidebar/GenericSidebar";
import IncomeDecDetails from "./IncomeDecDetails";
import di from "../../../di/serviceLocator";
import { getDateInFormat } from "@domains/utils/reportDates";
import { otplength, } from "@domains/salesFeatures/Clients/entities/iSendOTP";
import { useSelector } from "react-redux";
import moment from "moment";
import { serviceRequestConstent } from "../constents";
var IncomeDeclaration = function (props) {
    var _a, _b;
    var _c = __read(React.useState(false), 2), resendOtp = _c[0], setResendOtp = _c[1];
    var _d = __read(React.useState(false), 2), incomeDetails = _d[0], setIncomeDetails = _d[1];
    var _e = __read(React.useState(""), 2), dropdownValue = _e[0], setDropdownValue = _e[1];
    var _f = __read(React.useState(false), 2), resetFileUpload = _f[0], setResetFileUpload = _f[1];
    var _g = __read(React.useState({
        isFailed: false,
        isShow: false,
        msg: "",
    }), 2), serverMsg = _g[0], setServerMsg = _g[1];
    var _h = __read(React.useState(), 2), saveIncomeDeclaration = _h[0], setSaveIncomeDeclaration = _h[1];
    var _j = __read(React.useState(), 2), error = _j[0], setError = _j[1];
    var _k = __read(React.useState({
        fileContent: "",
        fileName: "",
    }), 2), formData = _k[0], setFormData = _k[1];
    var _l = __read(React.useState({
        mobilenumber: {
            otp: "",
            verifyOtp: false,
            error: "",
        },
    }), 2), otp = _l[0], setOtp = _l[1];
    var _m = __read(React.useState(), 2), viewIncomeDetails = _m[0], setViewIncomeDetails = _m[1];
    var _o = __read(React.useState(), 2), viewIncomeSRDetails = _o[0], setViewIncomeSRDetails = _o[1];
    var _p = __read(React.useState([]), 2), incomeRange = _p[0], setIncomeRange = _p[1];
    var _q = __read(React.useState([]), 2), clientType = _q[0], setClientTyps = _q[1];
    var _r = __read(React.useState([]), 2), nonClientType = _r[0], setNonClientTyps = _r[1];
    var _s = __read(React.useState(true), 2), disableSendOTPButton = _s[0], setDisableSendOTPButton = _s[1];
    var _t = __read(React.useState(""), 2), previousSelectedIncomeRange = _t[0], setPreviousSelectedIncomeRange = _t[1];
    var searchData = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var clientOverview = useSelector(function (state) { return state.Clients.ClientOverview.reducersData.data; });
    var profileData = useSelector(function (state) { var _a; return (_a = state.Profile.ProfileDetails.reducersData.data) === null || _a === void 0 ? void 0 : _a.profileDetails; });
    var getViewQRCDetails = function (selectedAcount) {
        di.clients
            .getViewIncomeDeclarationDetails(selectedAcount)
            .then(function (response) {
            if (response) {
                setViewIncomeDetails(response);
            }
        });
    };
    var getViewIncomeSRDEtails = function (selectedAccount) {
        di.clients
            .getViewIncomeDeclarationSRDetails(selectedAccount)
            .then(function (resp) {
            setViewIncomeSRDetails(resp);
        });
    };
    var handleChange = function (event) {
        var _a;
        var _b = event.target, name = _b.name, value = _b.value;
        setSaveIncomeDeclaration(__assign(__assign({}, saveIncomeDeclaration), (_a = {}, _a[name] = value, _a)));
    };
    var validationError = function (field, value) {
        var _a;
        setError(__assign(__assign({}, error), (_a = {}, _a[field] = value, _a)));
    };
    var getIncomeRange = function () {
        di.clients.getIncomeRange().then(function (resp) {
            setIncomeRange(resp);
        });
    };
    var getClientTypes = function () {
        di.clients.incomeDeclarationGetClientType().then(function (resp) {
            setClientTyps(resp);
        });
    };
    var getNonClientTypes = function () {
        di.clients.incomeDeclarationGetNonClientType().then(function (resp) {
            setNonClientTyps(resp);
        });
    };
    var sendOTP = function () {
        var payload = {
            Accode: props === null || props === void 0 ? void 0 : props.accountCode,
            incomeRange: saveIncomeDeclaration === null || saveIncomeDeclaration === void 0 ? void 0 : saveIncomeDeclaration.incomeRange,
            flag: "Income",
        };
        di.clients
            .sendOTP(payload)
            .then(function (response) {
            console.log("OTP response", response);
        })
            .catch(function (error) {
            console.log("OTP Error", error);
        });
    };
    var clientValidationHandler = function () {
        var payload = {
            acc_code: [searchData === null || searchData === void 0 ? void 0 : searchData.accountCode],
            callType: "Modification",
            subType: "Income Declaration",
            toDate: moment().format("yyyy-MM-DD"),
            fromDate: moment().subtract(30, "days").format("yyyy-MM-DD"),
            subStatus: "None",
            status: "Open",
        };
        di.clients
            .postIncomeClientValidation(payload)
            .then(function (data) {
            if (data &&
                data.data.statusCode == 200 &&
                data.data.message == "BOAcoountNumber not found") {
                updateServerMsg();
                serviceRequestHandler();
            }
            else {
                updateServerMsg(true, true, "Duplicate Request");
            }
        })
            .catch(function (error) {
            updateServerMsg(true, true, "Failed Client Request Validation from Badlaav Service Request");
        });
    };
    var getBOAccountNumber = function () {
        di.clients
            .getQRCDocDetailsData({
            flag: "Dpdetails",
            acCode: props === null || props === void 0 ? void 0 : props.accountCode,
            IsDematBank: "",
        })
            .then(function (resp) {
            if (resp && resp.length > 0) {
                resp.map(function (record) {
                    if (!!record.DPAcNo &&
                        record.DPAcNo !== "" &&
                        record.DPAcNo.includes("Default") &&
                        record.DPAcNo.includes("(")) {
                        var splitArray = record.DPAcNo.split("(");
                        if (splitArray && splitArray.length > 0) {
                            serviceRequestConstent.diS_BOAccountNumber = splitArray[0];
                        }
                        else {
                            serviceRequestConstent.diS_BOAccountNumber = "None";
                        }
                    }
                    else {
                        serviceRequestConstent.diS_BOAccountNumber = "None";
                    }
                });
            }
            else {
                serviceRequestConstent.diS_BOAccountNumber = "None";
            }
        })
            .catch(function (error) {
            serviceRequestConstent.diS_BOAccountNumber = "None";
        });
    };
    var serviceRequestHandler = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            serviceRequestConstent.createdUser = profileData === null || profileData === void 0 ? void 0 : profileData.empName;
            serviceRequestConstent.acCode = searchData === null || searchData === void 0 ? void 0 : searchData.accountCode;
            serviceRequestConstent.acName = searchData === null || searchData === void 0 ? void 0 : searchData.clientName;
            serviceRequestConstent.diS_Address = clientOverview === null || clientOverview === void 0 ? void 0 : clientOverview.address;
            serviceRequestConstent.diS_Email = clientOverview === null || clientOverview === void 0 ? void 0 : clientOverview.emailId;
            serviceRequestConstent.pan = clientOverview === null || clientOverview === void 0 ? void 0 : clientOverview.pan;
            serviceRequestConstent.mobileNo = clientOverview === null || clientOverview === void 0 ? void 0 : clientOverview.mobileNo;
            serviceRequestConstent.employeeName = clientOverview === null || clientOverview === void 0 ? void 0 : clientOverview.name;
            serviceRequestConstent.dealerCode = (_a = profileData === null || profileData === void 0 ? void 0 : profileData.userId) === null || _a === void 0 ? void 0 : _a.toString();
            serviceRequestConstent.diS_BOName = clientOverview === null || clientOverview === void 0 ? void 0 : clientOverview.name;
            serviceRequestConstent.arrFileName =
                formData.fileName == "" ? [] : [formData.fileName];
            serviceRequestConstent.arrbase64document =
                formData.fileContent == "" ? [] : [formData.fileContent];
            serviceRequestConstent.clientCategory = saveIncomeDeclaration === null || saveIncomeDeclaration === void 0 ? void 0 : saveIncomeDeclaration.clientTypeId;
            serviceRequestConstent.serviceRequestSecondary.secondary_request_data.gross_annual_income_range_code =
                saveIncomeDeclaration.inComeRangeID;
            serviceRequestConstent.serviceRequestSecondary.secondary_request_data.income_range =
                saveIncomeDeclaration.incomeRange;
            if (saveIncomeDeclaration.netWorthValue == "0" ||
                saveIncomeDeclaration.netWorthValue == "") {
                serviceRequestConstent.serviceRequestSecondary.secondary_request_data.net_worth_value =
                    "0";
                serviceRequestConstent.serviceRequestSecondary.secondary_request_data.net_worth_as_on_date =
                    "";
            }
            else {
                serviceRequestConstent.serviceRequestSecondary.secondary_request_data.net_worth_value =
                    saveIncomeDeclaration.netWorthValue;
                serviceRequestConstent.serviceRequestSecondary.secondary_request_data.net_worth_as_on_date =
                    moment().format("YYYY-MM-DD");
            }
            di.clients
                .postIncomeServiceRequest([serviceRequestConstent])
                .then(function (data) {
                var _a, _b, _c;
                if (data && (data === null || data === void 0 ? void 0 : data.result)) {
                    updateServerMsg(false, true, "Service Request Created Successfully ".concat(((_a = data === null || data === void 0 ? void 0 : data.result) === null || _a === void 0 ? void 0 : _a.id)
                        ? "- Service Request ID :" + ((_b = data === null || data === void 0 ? void 0 : data.result) === null || _b === void 0 ? void 0 : _b.id)
                        : ""));
                }
                else if (((_c = data === null || data === void 0 ? void 0 : data.clientId) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                    updateServerMsg(true, true, data === null || data === void 0 ? void 0 : data.message);
                }
                else {
                    updateServerMsg(true, true, "Failed creating Service Request");
                }
            })
                .catch(function (error) {
                console.log("updateServerMsgerror", error);
                updateServerMsg(true, true, "Failed creating Service Request");
            });
            return [2 /*return*/];
        });
    }); };
    var updateServerMsg = function (isError, isShow, msg) {
        setServerMsg({
            isFailed: isError ? isError : false,
            isShow: isShow ? isShow : false,
            msg: msg ? msg : "",
        });
    };
    var saveIncomeDeclarationForm = function () {
        var _a;
        di.clients
            .saveIncomeDeclaration(__assign(__assign({}, saveIncomeDeclaration), { createdBy: (_a = profileData === null || profileData === void 0 ? void 0 : profileData.userId) === null || _a === void 0 ? void 0 : _a.toString() }))
            .then(function (data) {
            if (data && (data === null || data === void 0 ? void 0 : data.success)) {
                updateServerMsg();
                di.clients
                    .getSubTypeMaster({
                    CallTypId: "18",
                    isubtypid: "190",
                })
                    .then(function (data) {
                    var _a;
                    if ((data === null || data === void 0 ? void 0 : data.success) && ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        clientValidationHandler();
                    }
                    else {
                        updateServerMsg(true, true, data.message);
                    }
                })
                    .catch(function (error) {
                    updateServerMsg(true, true, error.message);
                });
            }
            else {
                updateServerMsg(true, true, data.message);
            }
        })
            .catch(function (error) {
            updateServerMsg(true, true, error.message);
        });
    };
    var handleSubmitFile = function (fileDetails) {
        setResetFileUpload(false);
        if (fileDetails && fileDetails.docFile && fileDetails.base64Data) {
            setFormData({
                fileContent: fileDetails.base64Data.split(",")[1],
                fileName: fileDetails.docFile,
            });
        }
        else {
            setFormData({
                fileContent: "",
                fileName: "",
            });
        }
    };
    var verifyOTP = function (enteredotp) { return __awaiter(void 0, void 0, void 0, function () {
        var payloadValidateOtp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payloadValidateOtp = {
                        Accode: props === null || props === void 0 ? void 0 : props.accountCode,
                        otp: enteredotp,
                        Flag: "Income",
                    };
                    return [4 /*yield*/, di.clients.verifyOTP(payloadValidateOtp)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); };
    var handleResetDeclarationForm = function () {
        setSaveIncomeDeclaration(__assign(__assign({}, saveIncomeDeclaration), { inComeRangeID: "", netWorthValue: "0" }));
        setFormData({
            fileContent: "",
            fileName: "",
        });
        setResetFileUpload(true);
        setDisableSendOTPButton(true);
        setOtp(function (pre) { return (__assign(__assign({}, pre), { mobilenumber: __assign(__assign({}, pre.mobilenumber), { verifyOtp: false, error: "", otp: "" }) })); });
    };
    React.useEffect(function () {
        if (serverMsg.isShow) {
            setTimeout(function () {
                updateServerMsg();
            }, 10000);
        }
    }, [serverMsg.isShow]);
    React.useEffect(function () {
        if (clientOverview) {
            setSaveIncomeDeclaration({
                acCode: "",
                address: clientOverview.address,
                landline: clientOverview.phoneNo,
                mobileNo: clientOverview.mobileNo,
                email: clientOverview.emailId,
                visitDate: moment().format("YYYY-MM-DD"),
                incomeRange: "",
                assetsValue: "0",
                houseOwned: "0",
                vehicle: "0",
                fixedAssets: "0",
                jewelery: "0",
                bankBalance: "0",
                netWorthValue: "0",
                annualIncome: "0",
                currentAssets: "0",
                stock: "0",
                dematHoldingStatements: "0",
                others: "0",
                selectedRange: "",
                clientType: "",
                nonIndividual_Type: "",
                otherTypeText: "",
                pan: clientOverview.pan,
                acName: clientOverview.name,
                inComeRangeType: "",
                inComeRangeID: "",
                createdBy: "",
                emp_name: "",
                nonIndividual_TypeID: "0",
                clientTypeId: "0",
            });
        }
    }, [clientOverview]);
    React.useEffect(function () {
        getIncomeRange();
        getClientTypes();
        getNonClientTypes();
    }, []);
    React.useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.accountCode) {
            getViewQRCDetails(props.accountCode);
            getViewIncomeSRDEtails(props === null || props === void 0 ? void 0 : props.accountCode);
            console.log("viewIncomeSRDetails", viewIncomeSRDetails);
            getBOAccountNumber();
        }
    }, [props === null || props === void 0 ? void 0 : props.accountCode]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 px-0 dpledger-block" },
            React.createElement(Row, { className: "px-0 mx-0" },
                React.createElement(Col, { className: "px-0 HeadRow d-flex justify-content-between align-items-center" },
                    React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                        React.createElement("i", { className: "edel-icon-arrow-left1", onClick: function () {
                                props.closePopup(false);
                                setIncomeDetails(false);
                            } }),
                        "Income Declaration Form"),
                    React.createElement(EdButton, { className: "me-4 income-btn", btnTyp: "midnight-blue-underline", value: "View Income Declaration", onClick: function () { return setIncomeDetails(true); } })),
                React.createElement("div", { className: "income-body" },
                    React.createElement(Row, { className: "income-values m-0" },
                        React.createElement(Col, { xl: 3, lg: 3, className: "p-0" },
                            React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey head" }, "Income Range"),
                            React.createElement(SelectDropdown, { className: "Roboto_16_400", placeholderClassName: "", placeholder: "---Select---", name: "inComeRangeID", required: true, defaultValue: saveIncomeDeclaration === null || saveIncomeDeclaration === void 0 ? void 0 : saveIncomeDeclaration.inComeRangeID, dropdownOptions: incomeRange.filter(function (x, i) { return i !== 0; }), onChangeEvent: function (e) {
                                    var _a;
                                    setSaveIncomeDeclaration(__assign(__assign({}, saveIncomeDeclaration), { inComeRangeID: e.target.value, incomeRange: incomeRange.find(function (incomeRange) { return incomeRange.value === e.target.value; }).display }));
                                    if (((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) === "") {
                                        setDisableSendOTPButton(true);
                                    }
                                    else
                                        setDisableSendOTPButton(false);
                                    setOtp(function (pre) { return (__assign(__assign({}, pre), { mobilenumber: __assign(__assign({}, pre.mobilenumber), { verifyOtp: false, error: "", otp: "" }) })); });
                                    if (previousSelectedIncomeRange.length) {
                                        setResendOtp(false);
                                        if (previousSelectedIncomeRange.length &&
                                            previousSelectedIncomeRange === e.target.value) {
                                            setOtp(function (pre) { return (__assign(__assign({}, pre), { mobilenumber: __assign(__assign({}, pre.mobilenumber), { verifyOtp: true }) })); });
                                        }
                                    }
                                }, onBlur: function (error, event) {
                                    if (error.required)
                                        validationError(event.target.name, "Please select Income Range");
                                    else
                                        validationError(event.target.name, "");
                                }, errorText: error === null || error === void 0 ? void 0 : error.inComeRangeID })),
                        React.createElement(Col, { xl: 3, lg: 3, className: "p-0" },
                            React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey head" }, "Networth Value (In Rs)"),
                            React.createElement(InputField, { className: "Roboto_16_400", placeholderClassName: "", name: "netWorthValue", integer: true, type: "number", 
                                // required={true}
                                placeholder: "Enter Networth Value", defaultValue: saveIncomeDeclaration === null || saveIncomeDeclaration === void 0 ? void 0 : saveIncomeDeclaration.netWorthValue, onChangeEvent: handleChange, onBlur: function (error, event) {
                                    if (error.required)
                                        validationError(event.target.name, "This field is Required");
                                    else
                                        validationError(event.target.name, "");
                                }, errorText: error === null || error === void 0 ? void 0 : error.netWorthValue })),
                        React.createElement(Col, { className: "file-upload consent-fileupload-section p-0" },
                            React.createElement("div", { className: "d-feed-drag py-2" },
                                React.createElement(FileUploadSection, { reset: resetFileUpload, disableCross: false, fileType: ["pdf", "jpg", "svg", "png"], onSubmit: handleSubmitFile, fileSize: 8388608 })))),
                    React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1 my-4" }, "I hereby confirmed the information provided by the client is true & correct to the best of my knowledge"),
                    !formData.fileName && (React.createElement(React.Fragment, null, ((_a = otp === null || otp === void 0 ? void 0 : otp.mobilenumber) === null || _a === void 0 ? void 0 : _a.verifyOtp) ? (React.createElement("div", { className: "DMSanN_14_400 txt_green" },
                        React.createElement("i", { className: "edel-icon-success-circle me-2" }),
                        "OTP Verified")) : (React.createElement("div", { className: "d-flex otp-section align-items-center" },
                        React.createElement(EdButton, { className: "income-btn", btnTyp: "midnight-blue-underline", disabled: disableSendOTPButton, onClick: function () {
                                setResendOtp(true);
                                sendOTP();
                                setOtp(function (pre) { return (__assign(__assign({}, pre), { mobilenumber: __assign(__assign({}, pre.mobilenumber), { error: "", otp: "" }) })); });
                            }, value: resendOtp ? "Resend OTP" : "Send OTP" }),
                        resendOtp && (React.createElement("div", { className: "d-flex verify-otp" },
                            React.createElement("div", null,
                                React.createElement(InputField, { placeholderClassName: "", placeholder: "Enter OTP", type: "number", defaultValue: resendOtp ? "" : otp.mobilenumber.otp, onChange: function (value) {
                                        setOtp(function (pre) { return (__assign(__assign({}, pre), { mobilenumber: __assign(__assign({}, pre.mobilenumber), { otp: value }) })); });
                                    }, disabled: otp.mobilenumber.verifyOtp, suffix: otp.mobilenumber.verifyOtp === true ? (React.createElement("i", { className: "edel-icon-success-circle txt_green otp-verify" }, " ")) : (""), errorText: !otp.mobilenumber.verifyOtp &&
                                        otp.mobilenumber.error.length
                                        ? otp.mobilenumber.error
                                        : "" }),
                                React.createElement("label", { className: "txt-dark-greyish pt-2 DMSansNormal_12_400" }, "OTP is valid for 30 minute")),
                            React.createElement(EdButton, { slim: true, btnTyp: "midnight-blue-border", value: "Verify OTP", disabled: otp.mobilenumber.otp.length === Number(otplength) &&
                                    !otp.mobilenumber.verifyOtp
                                    ? false
                                    : true, onClick: function () {
                                    setPreviousSelectedIncomeRange(saveIncomeDeclaration.inComeRangeID);
                                    verifyOTP(otp.mobilenumber.otp)
                                        .then(function (data) {
                                        if (data) {
                                            console.log(data);
                                            setOtp(function (pre) { return (__assign(__assign({}, pre), { mobilenumber: __assign(__assign({}, pre.mobilenumber), { verifyOtp: data.data.flag, error: data.data.message, otp: "" }) })); });
                                        }
                                    })
                                        .catch(function (error) {
                                        if (error === null || error === void 0 ? void 0 : error.getMessage()) {
                                            setOtp(function (pre) { return (__assign(__assign({}, pre), { mobilenumber: __assign(__assign({}, pre.mobilenumber), { error: error === null || error === void 0 ? void 0 : error.getMessage() }) })); });
                                        }
                                    });
                                } }))))))),
                    serverMsg.isShow && (React.createElement("div", { className: "d-flex justify-content-center " },
                        React.createElement("span", { className: serverMsg.isFailed ? "text-danger" : "text-success" }, serverMsg.msg))),
                    React.createElement("div", { className: "d-flex justify-content-center income-buttons" },
                        React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Save", disabled: (!!error && Object.values(error).some(function (val) { return val; })) ||
                                !(saveIncomeDeclaration === null || saveIncomeDeclaration === void 0 ? void 0 : saveIncomeDeclaration.inComeRangeID) ||
                                !(saveIncomeDeclaration === null || saveIncomeDeclaration === void 0 ? void 0 : saveIncomeDeclaration.netWorthValue) ||
                                (!!previousSelectedIncomeRange &&
                                    previousSelectedIncomeRange !==
                                        saveIncomeDeclaration.inComeRangeID) ||
                                (!((_b = otp === null || otp === void 0 ? void 0 : otp.mobilenumber) === null || _b === void 0 ? void 0 : _b.verifyOtp) && !formData.fileName), onClick: function () {
                                saveIncomeDeclarationForm();
                            } }),
                        React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Reset", onClick: handleResetDeclarationForm }))))),
        React.createElement(GenericSidebar, { parentClassname: "income-sidebar", arrowClose: true, header: React.createElement("div", { className: "txt_blackOne1 DMSans_16_500 px-0 income-head" }, "Income Declaration Details"), body: React.createElement(IncomeDecDetails, { viewIncomeDeclarationDetails: viewIncomeDetails, lastDocUpload: viewIncomeSRDetails &&
                    viewIncomeSRDetails.updatedAt &&
                    (viewIncomeSRDetails === null || viewIncomeSRDetails === void 0 ? void 0 : viewIncomeSRDetails.updatedAt) !== ""
                    ? getDateInFormat(viewIncomeSRDetails.updatedAt, "DD MMM YY")
                    : "" }), footer: "", openKey: incomeDetails, setOpenKey: setIncomeDetails })));
};
export default IncomeDeclaration;
